import { cn } from '../../lib/cn'

type DotStatus = 'ok' | 'warn' | 'fail' | 'live'

interface StatusDotProps {
	status: DotStatus
	pulse?: boolean
	className?: string
}

/**
 * StatusDot — 8px circle indicator with optional glow ring.
 *
 *   live → cyan-400 + pulse (matches signature ring)
 *   ok   → emerald-400
 *   warn → amber-400
 *   fail → red-400
 *
 * Glow ring (box-shadow) is the pro tell — solid dot reads as a "live LED"
 * rather than a flat dot.
 */
function StatusDot({ status, pulse, className }: StatusDotProps) {
	const shouldPulse = pulse ?? status === 'live'

	return (
		<span
			className={cn(
				'inline-block w-2 h-2 rounded-full shrink-0',
				status === 'live' && 'bg-cyan-400 shadow-[0_0_6px_rgba(34,211,238,0.6)]',
				status === 'ok' && 'bg-emerald-400 shadow-[0_0_4px_rgba(52,211,153,0.4)]',
				status === 'warn' && 'bg-amber-400',
				status === 'fail' && 'bg-red-400 shadow-[0_0_4px_rgba(248,113,113,0.4)]',
				shouldPulse && 'animate-pulse',
				className,
			)}
			aria-hidden="true"
		/>
	)
}

export type { DotStatus }
export { StatusDot }
